import React from 'react'
import { Routes, Route } from 'react-router-dom'

// layouts
import NonAuthLayout from '../Layout/NonAuthLayout'
import { AuthProtected } from './AuthProtected'

import { authProtectedRoutes, publicRoutes } from './routes'
import VerticalLayout from '../Layout/VerticalLayout'

const Index = () => {
  return (
    <Routes>
      <Route>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}
      </Route>

      <Route>
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={ 
              <AuthProtected>
                <VerticalLayout>{route.component}</VerticalLayout>
              </AuthProtected>  
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>
    </Routes>
  )
}

export default Index
